import React, { useState, useCallback, useEffect } from "react";
import EducationItem from "../../steps/Education/EducationItem";
import EducationForm from "../../steps/Education/EducationForm";
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../redux/system/actions';
import ConfirmModal from "../../../common/modals/ConfirmModal";

const CONFIRM_MODAL_ID = 'confirmModal';

function EducationMainMenu({ curriculumVitae, handleSaveItem, handleDeleteItem, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [educations, setEducations] = useState(curriculumVitae.curriculumVitaeEducations || []);
    const [educationToDelete, setEducationToDelete] = useState(null);
    const [editingEducation, setEditingEducation] = useState(null);
    const [addingEducation, setAddingEducation] = useState(false);

    useEffect(() => {
        setEducations(curriculumVitae.curriculumVitaeEducations || []);
    }, [curriculumVitae.curriculumVitaeEducations]);


    const confirmDeleteEducation = async (education) => {
        setEducationToDelete(education);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    const handleSave = async (itemData, type) => {
        setAddingEducation(false);
        handleSaveItem(itemData, type);
    }

    return (
        <div className="cv-main-menu-overview">
            {(editingEducation || addingEducation) ? (
                <>
                    <h3 className="cv-main-menu-edit-mode">
                        {editingEducation ? 'Edit Mode' : 'Add Education'}
                    </h3>
                    <div className="main-menu-form-wrapper">
                        <EducationForm
                            curriculumVitaeId={curriculumVitae.id}
                            initialEducation={editingEducation}
                            setEditingEducation={setEditingEducation}
                            setAddingEducation={setAddingEducation}
                            onSave={(educationData) => handleSave(educationData, 'curriculumVitaeEducations')}
                            status={status}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="cv-main-menu-list">
                        <ul>
                            {curriculumVitae.curriculumVitaeEducations
                                .slice()
                                .sort((a, b) => {
                                    const dateA = a.currentStudy ? new Date() : new Date(a.endDate)
                                    const dateB = b.currentStudy ? new Date() : new Date(b.endDate);

                                    return dateB - dateA;
                                })
                                .map((education) => (
                                  <div key={education.id} className="main-menu-item-wrapper">
                                    <EducationItem
                                        education={education}
                                        onEdit={() => setEditingEducation(education)}
                                        onDelete={() => confirmDeleteEducation(education.id)}
                                    />
                                </div>
                            ))}
                        </ul>
                    </div>
                    <button className="cv-main-menu-add" onClick={() => setAddingEducation(true)}>
                        <i className="pe-7s-plus mr-2"></i>
                        Add another education
                    </button>
                </>
            )}

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this education?"
                message="This will permanently remove the selected education from your profile. Do you wish to proceed?"
                onConfirm={() => handleDeleteItem(educationToDelete, 'curriculumVitaeEducations')}
            />
        </div>
    );
}

export default EducationMainMenu;
